import isPermissionEnabled from "common/isPermissionEnabled"

export const APP_TYPES = {
  CUSTOMER: "customer",
  RIDER: "rider",
}

export const PAGE_CONTENT_PERMISSIONS = {
  [APP_TYPES.CUSTOMER]: {
    faq: {
      categoryId: 18,
      view: "faq_1",
      add: "faq_2",
      update: "faq_3",
      delete: "faq_4",
    },
    terms: {
      categoryId: 33,
      view: "term_condition_1",
      update: "term_condition_3",
    },
    privacy: {
      categoryId: 34,
      view: "privacy_policy_1",
      update: "privacy_policy_3",
    },
  },
  [APP_TYPES.RIDER]: {
    faq: {
      categoryId: 54,
      view: "rider_faq_1",
      add: "rider_faq_2",
      update: "rider_faq_3",
      delete: "rider_faq_4",
    },
    terms: {
      categoryId: 55,
      view: "rider_term_condition_1",
      update: "rider_term_condition_3",
    },
    privacy: {
      categoryId: 56,
      view: "rider_privacy_policy_1",
      update: "rider_privacy_policy_3",
    },
  },
}

export const getPageContentPermissions = (
  appType,
  contentKey,
  userRole,
  accountType
) => {
  const config =
    PAGE_CONTENT_PERMISSIONS[appType]?.[contentKey] ||
    PAGE_CONTENT_PERMISSIONS[APP_TYPES.CUSTOMER][contentKey]

  return {
    list: isPermissionEnabled(
      userRole,
      config.categoryId,
      config.view,
      accountType
    ),
    create: config.add
      ? isPermissionEnabled(
          userRole,
          config.categoryId,
          config.add,
          accountType
        )
      : false,
    edit: isPermissionEnabled(
      userRole,
      config.categoryId,
      config.update,
      accountType
    ),
    delete: config.delete
      ? isPermissionEnabled(
          userRole,
          config.categoryId,
          config.delete,
          accountType
        )
      : false,
  }
}

export const getAvailableAppTypes = (contentKey, userRole, accountType) => {
  const available = []
  if (
    getPageContentPermissions(
      APP_TYPES.CUSTOMER,
      contentKey,
      userRole,
      accountType
    ).list
  ) {
    available.push(APP_TYPES.CUSTOMER)
  }
  if (
    getPageContentPermissions(
      APP_TYPES.RIDER,
      contentKey,
      userRole,
      accountType
    ).list
  ) {
    available.push(APP_TYPES.RIDER)
  }
  return available
}

export const resolveActiveAppType = (requestedAppType, availableAppTypes) => {
  if (
    requestedAppType &&
    availableAppTypes.includes(requestedAppType)
  ) {
    return requestedAppType
  }
  return availableAppTypes[0] || APP_TYPES.CUSTOMER
}

export const withAppTypeQuery = (path, appType, extraParams = {}) => {
  const params = new URLSearchParams()
  if (appType) {
    params.set("appType", appType)
  }
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value))
    }
  })
  const query = params.toString()
  return query ? `${path}?${query}` : path
}
